<template>
  <span>{{ description }}</span>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/configuration";

export default {
  props: {
    status: {
      type: [String, Number],
      default: 0
    },
    workflowName: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters(api.namespace, [api.getters.getWorkflowForComponent]),
    workflow() {
      const workflow = this.getWorkflowForComponent(this.workflowName);
      return workflow;
    },
    description() {
      let status_item = this.workflow.status.find(item => {
        return item.id == this.status;
      });

      if (typeof status_item === "undefined") {
        console.warn(
          "status id unmappable try to map description",
          this.status,
          this.workflow.status
        );

        status_item = this.workflow.status.find(item => {
          return item.description == this.status;
        });
      }

      if (typeof status_item === "undefined") {
        console.error(
          "status description unmappable",
          this.status,
          this.workflow.status
        );
        return this.status;
      } else {
        console.assert(
          typeof status_item.description === "string",
          "workflow status item invalid",
          status_item
        );
        return status_item.description;
      }
    }
  }
};
</script>
